export default {"src":"/_next/static/media/warning2.ea3f81b2.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};